import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import {
  ResidentProfileActions,
  ResidentProfileActionTypes,
} from './resident-profile.actions';
import {
  IResidentProfileCommon,
  IResidentProfileTable,
  selectProfileId,
} from './resident-profile.interfaces';

export const residentProfileAdapter: EntityAdapter<IResidentProfileCommon> = createEntityAdapter<
  IResidentProfileCommon
>({
  selectId: selectProfileId,
});

export function residentProfileInitState(): IResidentProfileTable {
  return residentProfileAdapter.getInitialState({
    selectedProfileId: null,
    selectedRoleId: null,
  });
}

export function residentProfileReducer(
  state = residentProfileInitState(),
  action: ResidentProfileActions
) {
  switch (action.type) {
    case ResidentProfileActionTypes.REMOVE_ALL_PROFILES:
      return residentProfileAdapter.removeAll(state);
    case ResidentProfileActionTypes.LOAD_RESIDENT_PROFILE_SUCCESS:
      return residentProfileAdapter.addOne(action.payload, state);
    case ResidentProfileActionTypes.SET_RESIDENT_PROFILE_ID:
      return {
        ...state,
        selectedProfileId: action.payload,
      };
    case ResidentProfileActionTypes.SET_RESIDENT_ROLE_ID:
      return {
        ...state,
        selectedRoleId: action.payload,
      };
    case ResidentProfileActionTypes.UPDATE_RESIDENT_PROFILE_UNIT_ID:
      return residentProfileAdapter.updateOne(
        {
          id: action.profileId,
          changes: {
            unitId : action.payload,
          },
        },
        state
      );
    case ResidentProfileActionTypes.UPDATE_RESIDENT_PROFILE_SUCCESS:
      const currentImage =
        state.entities[action.payload.profile.profileId].profilePictureUrl;

      if (currentImage === action.payload.image) {
        return residentProfileAdapter.updateOne(
          {
            id: action.payload.profile.profileId,
            changes: {
              email: action.payload.profile.email,
              mobilePhone: action.payload.profile.mobilePhone,
              phone: action.payload.profile.phone,
              displayName: action.payload.profile.displayName,
              receiveNotificationEmail:
                action.payload.profile.receiveNotificationEmail,
              receiveNotificationSms:
                action.payload.profile.receiveNotificationSms,
              facebookProfile: action.payload.profile.facebookProfile,
              instagramProfile: action.payload.profile.instagramProfile,
              twitterHandle: action.payload.profile.twitterHandle,
              title: action.payload.profile.title,
            },
          },
          state
        );
      }

      let imageToUpdate: string = null;

      if (
        currentImage != null &&
        currentImage !== '' &&
        (action.payload.image === '' || action.payload.image == null)
      ) {
        imageToUpdate = currentImage;
      } else if (action.payload.image !== '' || action.payload.image != null) {
        imageToUpdate = action.payload.image;
      }

      return residentProfileAdapter.updateOne(
        {
          id: action.payload.profile.profileId,
          changes: {
            email: action.payload.profile.email,
            mobilePhone: action.payload.profile.mobilePhone,
            phone: action.payload.profile.phone,
            displayName: action.payload.profile.displayName,
            receiveNotificationEmail:
              action.payload.profile.receiveNotificationEmail,
            receiveNotificationSms:
              action.payload.profile.receiveNotificationSms,
            facebookProfile: action.payload.profile.facebookProfile,
            instagramProfile: action.payload.profile.instagramProfile,
            twitterHandle: action.payload.profile.twitterHandle,
            title: action.payload.profile.title,
            profilePictureUrl: imageToUpdate,
          },
        },
        state
      );

    default:
      return state;
  }
}
